import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const Signup = () => {
  return <div className="min-h-screen flex items-center justify-center bg-[#0F1115] py-12 px-4 sm:px-6 lg:px-8 relative" data-id="element-1599">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1600"></div>

      <div className="max-w-md w-full space-y-8 relative z-10" data-id="element-1601">
        <div className="text-center" data-id="element-1602">
          <h1 className="text-3xl font-bold text-white" data-id="element-1603">Create your account</h1>
          <p className="mt-2 text-gray-400" data-id="element-1604">
            Join our community of developers and employers
          </p>
        </div>
        <div className="bg-[#1a1d24] p-8 rounded-2xl border border-gray-800 shadow-lg" data-id="element-1605">
          <form className="space-y-6" data-id="element-1606">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-1607">
              <div data-id="element-1608">
                <label htmlFor="first_name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1609">
                  First name
                </label>
                <input id="first_name" name="first_name" type="text" required className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" data-id="element-1610" />
              </div>
              <div data-id="element-1611">
                <label htmlFor="last_name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1612">
                  Last name
                </label>
                <input id="last_name" name="last_name" type="text" required className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" data-id="element-1613" />
              </div>
            </div>
            <div data-id="element-1614">
              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1615">
                Email address
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" placeholder="you@example.com" data-id="element-1616" />
            </div>
            <div data-id="element-1617">
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1618">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="new-password" required className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" data-id="element-1619" />
              <p className="mt-2 text-xs text-gray-500" data-id="element-1620">
                Password must be at least 8 characters and include a number and
                special character.
              </p>
            </div>
            <div data-id="element-1621">
              <label htmlFor="account_type" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1622">
                I am a...
              </label>
              <select id="account_type" name="account_type" className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" data-id="element-1623">
                <option value="developer" data-id="element-1624">Developer</option>
                <option value="employer" data-id="element-1625">Employer</option>
                <option value="agency" data-id="element-1626">Agency / Team</option>
              </select>
            </div>
            <div className="flex items-center" data-id="element-1627">
              <input id="terms" name="terms" type="checkbox" required className="h-4 w-4 text-[#d73b3e] focus:ring-[#d73b3e] border-gray-700 rounded bg-[#0F1115]" data-id="element-1628" />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-300" data-id="element-1629">
                I agree to the{' '}
                <Link to="/terms-of-service" className="text-[#d73b3e] hover:text-[#c02f32]" data-id="element-1630">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy-policy" className="text-[#d73b3e] hover:text-[#c02f32]" data-id="element-1631">
                  Privacy Policy
                </Link>
              </label>
            </div>
            <div data-id="element-1632">
              <button type="submit" className="w-full px-6 py-3 bg-[#d73b3e] text-white rounded-full font-semibold hover:bg-[#c02f32] transition-all duration-300 shadow-lg" data-id="element-1633">
                Create Account
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-1634">
            <div className="relative" data-id="element-1635">
              <div className="absolute inset-0 flex items-center" data-id="element-1636">
                <div className="w-full border-t border-gray-800" data-id="element-1637" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1638">
                <span className="px-2 bg-[#1a1d24] text-gray-400" data-id="element-1639">
                  Or sign up with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1640">
              <a href="#" className="w-full inline-flex justify-center py-3 px-4 border border-gray-800 rounded-xl bg-[#0F1115] text-sm font-medium text-gray-300 hover:bg-gray-800 transition-colors" data-id="element-1641">
                <span className="sr-only" data-id="element-1642">Sign up with GitHub</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-1643">
                  <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" data-id="element-1644" />
                </svg>
              </a>
              <a href="#" className="w-full inline-flex justify-center py-3 px-4 border border-gray-800 rounded-xl bg-[#0F1115] text-sm font-medium text-gray-300 hover:bg-gray-800 transition-colors" data-id="element-1645">
                <span className="sr-only" data-id="element-1646">Sign up with Google</span>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1647">
                  <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-1648" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-1649">
          <p className="text-sm text-gray-400" data-id="element-1650">
            Already have an account?{' '}
            <Link to="/login" className="font-medium text-[#d73b3e] hover:text-[#c02f32] transition-colors" data-id="element-1651">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Signup;